import { TimetableReports } from '../../../components/EvaluateTimetable/TimetableReports';

export const EvaluateByRooms = () => {
  return <TimetableReports topic='rooms' />;
};
